export const noteKeys = {
  base: ["notes"] as const,
  summary: (patientId: string) => [...noteKeys.base, patientId, "summary"] as const,
};
